import { Flex, Modal, ModalProps, Typography } from 'antd';

interface ICustomModalProps extends ModalProps {
  icon?: React.ReactNode;
  title: React.ReactNode;
  header?: React.ReactNode;
}

export const CustomModal = ({
  children,
  title,
  header,
  icon,
  ...props
}: ICustomModalProps) => {
  return (
    <Modal
      {...props}
      title={
        header ? (
          header
        ) : (
          <Flex align="center" gap={16}>
            {icon && (
              <div className="bg-primary-100 rounded-md py-3 px-4 text-primary-500 text-xl">
                {icon}
              </div>
            )}
            <Typography.Title level={4} className="!mb-0 !font-semibold">
              {title}
            </Typography.Title>
          </Flex>
        )
      }
    >
      {children}
    </Modal>
  );
};
